import React from 'react';
import { connect } from 'react-redux';
import Row from '../../shared/components/Row';
import Card from '../../shared/components/Card';
import CardBody from '../../shared/components/CardBody';
import PaperBinTabWorkers from './PaperBinTabWorkers';
import PaperBinTabMachines from './PaperBinTabMachines';

class PaperBinCard extends React.Component {

    render() {
        return (
            <Row>
                <Card colWidth={'col-md-12'} loading={this.props.loading}>
                    <CardBody className={'table-responsive'}>
                        <ul className="nav nav-tabs" role="tablist">
                            {PaperBinTabWorkers.renderTabHeader()}
                            {PaperBinTabMachines.renderTabHeader()}
                        </ul>
                        <div className="tab-content">
                            <PaperBinTabWorkers/>
                            <PaperBinTabMachines/>
                        </div>
                    </CardBody>
                </Card>
            </Row>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {
        loading: state.paperBin.loading,
    };
};

export default connect(mapStateToProps)(PaperBinCard);



// WEBPACK FOOTER //
// ./src/app/paperbin/components/PaperBinCard.js